function isInApp() {
    //通过user-agent判断是否在app中打开
    let userAgent = navigator.userAgent.toLowerCase();
    if (/jinhua/gi.test(userAgent)) {
        return true;
    } else {
        return false;
    }

};

//获取系统信息
function getSystemInfo(callback) {
    if (window.flutter_inappwebview) {
        window.flutter_inappwebview
            .callHandler("getSystemInfo")
            .then((response) => {
                if (typeof response == "string") {
                    response = JSON.parse(response);
                }
                callback && callback(response);
            });
    }
};

//获取用户信息
function getUserInfo(callback) {
    if (window.flutter_inappwebview) {
        window.flutter_inappwebview
            .callHandler("getUserInfo")
            .then((response) => {
                if (typeof response == "string") {
                    response = JSON.parse(response);
                    console.log("获取")
                }
                callback && callback(response);
            });
    }
};

//获取坐标信息
function getLocation(callback) {
    if (window.flutter_inappwebview) {
        window.flutter_inappwebview
            .callHandler("getLocation")
            .then((response) => {
                if (typeof response == "string") {
                    response = JSON.parse(response);
                }
                callback && callback(response);
            });
    }
};

/**
 *  唤起分享
 *  option
 *  {
 *    is_set: 0, 0:唤起分享 1:仅进行分享设置
            title: '这是分享标题',
            brief: '这是分享简介',
            link_url: '',
            indexpic: ''
          }
 */
function shareTo(option = {}) {
    if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler("shareTo", option);
    }
};
//跳转到登录页面
function goToLoginPage() {
    if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler("goToLoginPage");
    }
};
//跳转到绑定微信页面
function goToBindPage() {
    if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler("goToBindPage");
    }
};
//保存图片
function saveImage(option = {}) {
    if (!option.url) {
        return;
    }
    if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler("saveImage", {
            url: option.url,
        });
    }
};
//内置webview跳转链接
function linkTo(url = "") {
    if (!url) {
        return;
    }
    if (window.flutter_inappwebview) {
        window.flutter_inappwebview.callHandler("linkTo", {
            url: url,
        });
    }
};

function judgeWebViewIsInApp(callback){
    if (window.flutter_inappwebview) {
        window.flutter_inappwebview
            .callHandler("judgeWebViewIsInApp")
            .then((response) => {
             
                callback && callback(response);
            });
    }else{
        callback && callback("noapp");
    }
}

export {
    isInApp,
    getSystemInfo,
    getUserInfo,
    getLocation,
    shareTo,
    goToLoginPage,
    goToBindPage,
    saveImage,
    linkTo,
    judgeWebViewIsInApp
}



